import React from 'react';
import classnames from 'classnames/bind';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './chatMessage.module.scss';

const classNameBuilder = classnames.bind(styles);

const ChatMessageBase = ({ message, messageId, defaultText, text }) => {
    if (message) {
        return message;
    }

    if (messageId) {
        return <FormattedMessage id={messageId} defaultMessage={defaultText} />;
    }

    return text;
};

export const ChatMessage = ({ sender, ...rest }) => (
    <div className={classNameBuilder('container', sender)}>
        <p className={classNameBuilder('message', sender)}>
            <ChatMessageBase {...rest} />
        </p>
    </div>
);
